// Analytics tracking helpers — safe no-op if dataLayer isn't loaded (dev)
export const trackEvent = (event, params = {}) => {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    }
  } catch (_) {
    /* no-op */
  }
};

export const trackWhatsappClick = (context = "") => {
  trackEvent("whatsapp_click", { context });
};

export const trackPhoneClick = (context = "") => {
  trackEvent("phone_click", { context });
};

export const trackEmailClick = (context = "") => {
  trackEvent("email_click", { context });
};

export const trackGenerateLead = (destination = "", source = "") => {
  trackEvent("generate_lead", {
    currency: "INR",
    value: 0,
    destination,
    source,
  });
};
